import {api} from '../../helpers';

function fetchInvoices({params}) {
  const {...queryParams} = params;
  return api
    .get(`utils/einvoicing/fetch-invoices`, {params: queryParams})
    .then(res => res.data);
}

function fetchInvoiceOverview({params}) {
  const {...queryParams} = params;
  return api
    .get(`utils/einvoicing/invoice-overview`, {params: queryParams})
    .then(res => res.data);
}

export {fetchInvoices, fetchInvoiceOverview};
